import { ReactNode } from "react";
import { cn } from "../../lib/utils";
import { ClassValue } from "clsx/clsx";

const Container = ({
  children,
  className,
}: {
  children?: ReactNode;
  className?: ClassValue;
}) => {
  return (
    <div
      className={cn(
        "w-[320px] 2xl:w-[1313px] lg:w-[1024px] md:w-[768px]",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Container;
